import React from 'react';
import MaskedInput from 'react-text-mask';
import { createNumberMask } from 'helpers/create-number-mask';

interface ICurrencyField {
  placeholder?: string;
  value: string;
  disabled?: boolean;
  onChange: (data: string) => void;
  error?: string;
  onBlur?: () => void;
  height?: string;
  prefix?: string;
  allowDecimal?: boolean;
  includeThousandsSeparator?: boolean;
}
const CurrencyInputComponent: React.FC<ICurrencyField> = ({
  value = '',
  onChange = (data: string) => {},
  placeholder = '',
  error = '',
  disabled = false,
  onBlur = () => {},
  height = 'h-12',
  prefix = '€',
  allowDecimal = true,
  includeThousandsSeparator = true,
}) => {
  return (
    <div className="flex-col items-center w-full relative ">
      <MaskedInput
        className={`flex items-center px-4 h-10 placeholder:text-sm ${`lg:${height}`} border-1.5 rounded-1 bg-white border-grey focus:border-active outline-none text-base text-black2  placeholder:text-grey2 disabled:bg-grey1 w-full ${
          error ? 'border-red-500' : ''
        } ${disabled ? 'opacity-50' : ''}`}
        mask={createNumberMask({
          prefix: prefix,
          allowDecimal: allowDecimal,
          includeThousandsSeparator: includeThousandsSeparator,
        })}
        placeholder={`${prefix} ${placeholder}`}
        value={value}
        prefix={prefix}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={onBlur}
      />
      {error && <p className="font-regular text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default CurrencyInputComponent;
